<template>
  <div class="box">
    <!-- 基本信息 -->
    <div class="title">
      <p>基本信息</p>
    </div>
    <div class="case-box">
      <FirmMsg></FirmMsg>
    </div>
    <!-- 公司简介 -->
    <div class="title">
      <p>公司简介</p>
    </div>
    <p class="ServiceDetails">
      喀什最大最高端的楼盘，只要认真对待工作，每月工资最少都在2万以上，感兴趣可以联系我喀什最大最高端的楼盘，只要认真对待工作，每月工资最少都在2万以上，感兴趣可以联系我
      喀什最大最高端的楼盘，只要认真对待工作，每月工资最少都在2万以上，感兴趣可以联系我
      工资最少都在2万以上，感兴趣可以联系我喀什最大最高端的楼盘，只要认真对待工作，每月工资最少都在2万以上，感兴趣可以联系我
      喀什最大最高端的楼盘，只要认真对待工作，每月工资最少都在2万以上，感兴趣可以联系我
    </p>
    <!-- 工商信息 -->
    <div class="title">
      <p>工商信息</p>
    </div>
    <div class="case-box">
      <FirmMessage></FirmMessage>
    </div>
    <!-- 服务范围 -->
    <div class="title">
      <p>服务范围</p>
    </div>
    <div class="service" v-for="(item, index) in listRadiusArr" :key="index">
      <p class="service-title">{{ item.name }}</p>
      <div class="serviceItem">
        <p v-for="(item1, index1) in item.child" :key="index1">
          {{ item.name }}
        </p>
      </div>
    </div>
    <!-- 企业详情 -->
    <div class="title">
      <p>企业详情</p>
    </div>
    <p class="ServiceDetails">
      创意无限，品质至上！我们的宣传册设计服务，为您的品牌量身打造独特魅力。从构思到呈现，每一步都充满匠心与热情。
      让您的宣传册成为市场中的亮点，吸引更多目光。选择我们，让您的品牌故事在精美的设计中绽放光彩！
    </p>
    <div class="Details-picture"></div>
    <!-- 服务商品 -->
    <div class="title">
      <p>服务商品</p>
    </div>
    <div class="case-box">
      <ServiceItem :listArr="listProductArr"></ServiceItem>
    </div>
    <!-- 分页 -->
    <div class="paging-box">
      <div class="paging">
        <paging
          :pagingObj="pagingProduct"
          @handleCurrentChange="handleCurrentProduct"
        ></paging>
      </div>
    </div>
    <!-- 成功案例 -->
    <div class="title">
      <p>成功案例</p>
    </div>
    <div class="case-box">
      <Case
        :listArr="listArr1"
        :distinguish="2"
        @handelEditCase="handelEditCase"
      ></Case>
    </div>
    <!-- 分页 -->
    <div class="paging-box">
      <div class="paging">
        <paging
          :pagingObj="pagingObj"
          @handleCurrentChange="handleCurrentChange"
        ></paging>
      </div>
    </div>
    <!-- 评论 -->
    <div class="title">
      <p>评论</p>
      <div class="mark">
        平均评分：
        <div class="star" v-for="(item, index) in mark" :key="index + 1"></div>
        <div
          class="null"
          v-for="(item, index) in 5 - mark"
          :key="index + 10"
        ></div>
        <span>4 星</span>
      </div>
    </div>
    <div class="case-box">
      <Review :listArr="listArr" :distinguish="2"></Review>
    </div>
    <!-- 分页 -->
    <div class="paging-box">
      <div class="paging">
        <paging
          :pagingObj="paging"
          @handleCurrentChange="handleCurrent"
        ></paging>
      </div>
    </div>
  </div>
</template>

<script>
import Case from "../../HelpShop/moduleTwe/components/Case.vue"; // 案例信息
import Review from "../../HelpShop/moduleSix/components/Review.vue"; // 评论
import ServiceItem from "../components/ServiceItem.vue"; // 服务商品
import paging from "../../../../../components/paging.vue"; // 分页
import FirmMessage from "../../HelpShop/moduleTwe/components/FirmMessage.vue"; // 工商信息
import FirmMsg from "../components/FirmMsg.vue"; // 公司信息
export default {
  props: {},
  data() {
    return {
      listArr1: [
        {
          choose: false, //选择 0未  1是
        },
        {
          choose: false, //选择 0未  1是
        },
        {
          choose: false, //选择 0未  1是
        },
      ], // 案例信息
      pagingProduct: {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      }, // 商品分页数据
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      }, // 案例分页数据
      paging: {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      }, // 评论分页数据
      mark: 4,
      listArr: [
        {
          status: 0,
          mark: 4,
          EvaluationTag: [
            {
              name: "准时守信",
              id: "1",
            },
            {
              name: "值得推荐",
              id: "2",
            },
          ],
        },
        {
          status: 1,
          mark: 3,
          EvaluationTag: [
            {
              name: "准时守信",
              id: "1",
            },
            {
              name: "值得推荐",
              id: "2",
            },
          ],
        },
        {
          status: 0,
          mark: 4,
          EvaluationTag: [
            {
              name: "准时守信",
              id: "1",
            },
            {
              name: "值得推荐",
              id: "2",
            },
          ],
        },
      ], // 评论数据
      listProductArr: [
        {
          status: "0", // 状态 0已上架  1审核  2审核失败 3已下架
          choose: false,
        },
        { status: "0", choose: false },
        { status: "0", choose: false },
        { status: "1", choose: false },
        { status: "2", choose: false },
        { status: "3", choose: false },
        { status: "2", choose: false },
        { status: "0", choose: false },
      ], //服务商品数据
      listRadiusArr: [
        {
          name: "工商服务",
          child: [
            {
              name: "企业名称变更",
            },
            {
              name: "公司地址变更",
            },
            {
              name: "工商年报",
            },
          ],
        },
        {
          name: "财税服务",
          child: [
            {
              name: "个体户代账",
            },
            {
              name: "小规模代账",
            },
            {
              name: "一般纳税人代账",
            },
          ],
        },
      ], //服务范围
    };
  },
  components: {
    // 案例
    Case,
    // 分页
    paging,
    // 评论
    Review,
    // 服务商品
    ServiceItem,
    // 工商信息
    FirmMessage,
    // 公司信息
    FirmMsg,
  },
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    // 点击案例模块
    handelEditCase(val) {
      this.$emit("handelEditCase", val);
    },
    // 商品分页
    handleCurrentProduct(val) {
      this.pagingProduct.currentPage = val;
    },
    // 分页
    handleCurrentChange(val) {
      this.pagingObj.currentPage = val;
    },
    // 评论分页
    handleCurrent(val) {
      this.paging.currentPage = val;
    },
  },
};
</script>

<style scoped lang="less">
//
.box {
  width: 100%;
  height: 100%;
  font-family: PingFangSC-Medium;
  font-weight: 400;
  color: #666666;
  // 标题
  .title {
    width: 100%;
    height: 25px;
    line-height: 25px;
    display: flex;
    margin: 40px 0px 30px 0px;
    p {
      min-width: 80px;
      height: 100%;
      background-image: url("../../../../../assets/imgs/zhuangshi@3x.svg");
      background-size: 100% 40%;
      background-repeat: no-repeat;
      background-position-y: bottom;
      font-size: 20px;
      color: #333333;
      text-align: center;
    }
    .mark {
      min-width: 100px;
      display: flex;
      margin-left: 40px;
      .star {
        width: 15px;
        height: 14px;
        background-image: url("../../../../../assets/imgs/shoucang@3x.svg");
        background-size: 100% 100%;
        margin: auto 0;
        margin-right: 2px;
      }
      .null {
        width: 15px;
        height: 14px;
        background-image: url("../../../../../assets/imgs/shoucang-null@3x.svg");
        background-size: 100% 100%;
        margin: auto 0;
        margin-right: 2px;
      }
      span {
        margin-left: 5px;
      }
    }
  }
  // 服务范围
  .service {
    width: 100%;
    min-height: 70px;
    .service-title {
      width: 100%;
      height: 17px;
      line-height: 17px;
      font-size: 14px;
      color: #333333;
    }
    .serviceItem {
      width: 100%;
      min-height: 55px;
      display: flex;
      flex-wrap: wrap;
      margin-top: 5px;
      p {
        min-width: 110px;
        height: 33px;
        line-height: 33px;
        background: rgba(97, 144, 232, 0.2);
        border: 1px solid #409eff ;
        border-radius: 5px;
        font-size: 12px;
        color: #409eff ;
        text-align: center;
        margin-bottom: 20px;
        margin-right: 20px;
      }
    }
  }
  // 服务详情
  .ServiceDetails {
    width: 1140px;
    font-size: 14px;
    color: #333333;
    line-height: 30px;
    text-indent: 28px;
  }
  .Details-picture {
    width: 601px;
    height: 270px;
    background: #eeeeee;
    margin: 0 auto;
    margin-top: 20px;
  }
  // 案例信息
  .case-box {
    width: 1140px;
    min-height: 120px;
  }
}
// 分页
.paging-box {
  width: 100%;
  height: 22px;
  margin-top: 0px;
  display: flex;
  justify-content: flex-end;
  .paging {
    width: 90%;
    height: 100%;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
